import Nullstack from 'nullstack';
export default function IconBrandSuperhuman({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-superhuman",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 12l4 3l-8 7l-8 -7l4 -3"
  }), "   ", Nullstack.element("path", {
    d: "M12 3l-8 6l8 6l8 -6z"
  }), "   ", Nullstack.element("path", {
    d: "M12 15h8"
  }), " ");
}